export default __webpack_public_path__ + "static/media/(38)-min.c52fcebb.JPG";